__turbopack_context__.v({
  "disclaimerContainer": "OptinTemplate-module__DI__4a__disclaimerContainer",
  "disclaimerContainerLandscape": "OptinTemplate-module__DI__4a__disclaimerContainerLandscape",
  "inputContainer": "OptinTemplate-module__DI__4a__inputContainer",
  "inputContainerLandscape": "OptinTemplate-module__DI__4a__inputContainerLandscape",
  "optinContainer": "OptinTemplate-module__DI__4a__optinContainer",
  "panelContainer": "OptinTemplate-module__DI__4a__panelContainer",
  "panelContainerLandscape": "OptinTemplate-module__DI__4a__panelContainerLandscape",
});
